import i18n from '@/plugins/i18n';

const NAVTAB_AMQ_LABEL = Object.freeze({
  OVERVIEW: i18n.global.t('mq.overview'),
  QUEUES: i18n.global.t('mq.queues'),
  TOPICS: i18n.global.t('mq.topics'),
});

const NAVTAB_AMQ_KEY = Object.freeze({
  OVERVIEW: 'amq-overview',
  QUEUES: 'amq-queues',
  TOPICS: 'amq-topics',
});

const NAVTAB_KAFKA_LABEL = Object.freeze({
  OVERVIEW: i18n.global.t('mq.overview'),
  PRODUCER: i18n.global.t('mq.producer'),
  BROKER: i18n.global.t('mq.broker'),
  CONSUMER: i18n.global.t('mq.consumer'),
  ZOOKEEPER: i18n.global.t('mq.zooKeeper'),
});

const NAVTAB_KAFKA_KEY = Object.freeze({
  OVERVIEW: 'kafka-overview',
  PRODUCER: 'kafka-producer',
  BROKER: 'kafka-broker',
  CONSUMER: 'kafka-consumer',
  ZOOKEEPER: 'kafka-zookeeper',
});

const KAFKA_OVERVIEW_TAB_KEY = Object.freeze({
  BROKER: 'kafka-overview-broker',
  PRODUCER: 'kafka-overview-producer',
  CONSUMER: 'kafka-overview-consumer',
});

const KAFKA_PRODUCER_TAB_KEY = Object.freeze({
  BROKER: 'kafka-producer-broker',
  TOPIC: 'kafka-producer-topic',
});

const KAFKA_CONSUMER_TAB_KEY = Object.freeze({
  PARTITION: 'kafka-consumer-partition',
  REQUEST: 'kafka-consumer-request',
  CONNECTION: 'kafka-consumer-connection',
});

const KAFKA_BROKER_TAB_KEY = Object.freeze({
  TOPIC: 'kafka-broker-topic',
  JVM: 'kafka-broker-jvm',
});

const DISABLED_TOPIC_METRICS_GRAPH_EXCLUDING_AWS = ['kafka_consumer_group_lag'];
const DISABLED_JVM_METRICS_GRAPH_FOR_AWS = [
  'kafka_broker_cpu_usage',
  'kafka_jvm_young_gc_time',
  'kafka_jvm_old_gc_time',
  'kafka_jvm_young_gc_count',
  'kafka_jvm_old_gc_count',
  'kafka_broker_thread_count',
];

const KAFKA_ZOOKEEPER_TAB_KEY = Object.freeze({
  SESSION: 'kafka-zookeeper-session',
});

export {
  NAVTAB_AMQ_LABEL,
  NAVTAB_AMQ_KEY,
  NAVTAB_KAFKA_LABEL,
  NAVTAB_KAFKA_KEY,
  KAFKA_OVERVIEW_TAB_KEY,
  KAFKA_PRODUCER_TAB_KEY,
  KAFKA_CONSUMER_TAB_KEY,
  KAFKA_BROKER_TAB_KEY,
  KAFKA_ZOOKEEPER_TAB_KEY,
  DISABLED_TOPIC_METRICS_GRAPH_EXCLUDING_AWS,
  DISABLED_JVM_METRICS_GRAPH_FOR_AWS,
};
